import emit from '../../common/events';

/**
 * Analytics events for mhecomm-article-cards.
*/
export class ArticleCardsAnalytics {
  /**
   * Fired when the user clicks the card body (the linked article).
   */
  static cardClick(
    element: Element,
    listId: string,
    url: string,
    subarea: string,
    tags: string,
  ): void {
    emit({
      element,
      name: 'click',
      detail: {
        eventName: `${listId}-card-click-event`,
        comp: 'article-card',
        url,
        subarea,
        articletags: tags,
      },
    });
  }

  /**
   * Fired when the user clicks the CTA button or link inside a card.
   */
  static ctaClick(
    element: Element,
    listId: string,
    url: string,
    subarea: string,
    tags: string,
    ctaComp: 'button' | 'link',
  ): void {
    emit({
      element,
      name: 'click',
      detail: {
        eventName: `${listId}-card-click-event`,
        comp: ctaComp,
        url,
        subarea,
        articletags: tags,
      },
    });
  }

  /**
   * Fired when the user clicks a pagination page button (prev, next, or numbered).
   */
  static paginationClick(
    element: Element,
    listId: string,
    page: number,
    subarea: string,
  ): void {
    emit({
      element,
      name: 'click',
      detail: {
        eventName: `${listId}-pagination-click-event`,
        comp: 'article-card-pagination',
        page,
        subarea,
      },
    });
  }
}
